const isSameObject = <T>(ob1: T | null, ob2: T | null, keysToBeIgnored: string[] = []): boolean => {
  // If both null, then true
  if (!ob1 && !ob2) return true;
  // only either one null, but not both, then false
  if (!ob1 || !ob2) return false;

  // if both not null, well then, check things
  const keys1 = Object.keys(ob1).filter((key) => !keysToBeIgnored.includes(key));
  const keys2 = Object.keys(ob2).filter((key) => !keysToBeIgnored.includes(key));
  // both the same key count?
  if (keys1.length !== keys2.length) {
    return false;
  }
  // both any keys at all?
  if (!keys1.length) {
    return true;
  }

  // deep check
  return keys1.every((key) => {
    if (typeof ob1[key] === "object") {
      return isSameObject<keyof T>(ob1[key], ob2[key]);
    }

    return ob1[key] === ob2[key];
  });
};

export default isSameObject;
